import types from './types'

export const initialState = {
  error: null,
  // TODO: Update to user action specific message when site users are fully wired up
  message: 'Loading',
  sites: {
    data: null,
    isLoading: false,
    criteria: {},
  },
  // TODO: Update this reducer to store users by site
  siteUsers: {
    addBulkUsersResponse: null,
    data: null,
    isLoading: false,
    isDeleting: false,
    isUpdating: false,
    isBulkOperationCompleted: false,
  },
  remindUsers: {
    success: null,
    isLoading: false,
  },
  mergeSiteState: {
    isMerging: false,
    mergeSiteResults: null,
    mergeSiteError: null,
  },
}

const productOrder = ['K8P', 'ADL', 'BPU', 'CPU']

const sortLicensesBySku = (licenseA, licenseB) => {
  const { sku: licenseASku } = licenseA.product
  const { sku: licenseBSku } = licenseB.product
  return productOrder.indexOf(licenseASku) - productOrder.indexOf(licenseBSku)
}

const sortListByName = (siteA, siteB) => {
  if (siteA.name < siteB.name) {
    return -1
  }
  if (siteA.name > siteB.name) {
    return 1
  }
  return 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_SITES:
      return {
        ...state,
        error: null,
        message: 'Loading',
        sites: {
          data: null,
          isLoading: false,
          criteria: {},
        },
        siteUsers: {
          data: null,
          isLoading: false,
        },
      }
    case types.FETCHING_SITES:
    case types.FETCHING_SITES_SUCCESS:
    case types.FETCHING_SITES_ERROR:
      if (action.type === types.FETCHING_SITES_SUCCESS) {
        action.sites.forEach(site => {
          site.licenses.sort(sortLicensesBySku)
        })
      }
      return {
        ...state,
        error: action.type === types.FETCHING_SITES_ERROR ? action.error : null,
        sites: {
          ...state.sites,
          data:
            action.type === types.FETCHING_SITES_SUCCESS
              ? action.sites.sort(sortListByName)
              : state.sites.data,
          isLoading: action.type === types.FETCHING_SITES,
        },
      }
    case types.MERGING_SITE:
    case types.MERGING_SITE_SUCCESS:
    case types.MERGING_SITE_ERROR:
      return {
        ...state,
        mergeSiteState: {
          isMerging: action.type === types.MERGING_SITE,
          mergeSiteResults:
            action.type === types.MERGING_SITE_SUCCESS
              ? action.mergeSiteResults
              : null,
          mergeSiteError:
            action.type === types.MERGING_SITE_ERROR
              ? action.mergeSiteError
              : null,
        },
      }
    case types.SET_SITE_SEARCH_CRITERIA:
      return {
        ...state,
        sites: {
          ...state.sites,
          criteria: action.criteria,
        },
      }

    case types.UPDATING_SITE:
    case types.UPDATING_SITE_SUCCESS:
    case types.UPDATING_SITE_ERROR:
      // this PUT call returns no data:
      return {
        ...state,
        error: action.type === types.UPDATING_SITE_ERROR ? action.error : null,
        isLoading: action.type === types.UPDATING_SITE,
      }
    case types.FETCHING_SITE_USERS:
    case types.FETCHING_SITE_USERS_SUCCESS:
    case types.FETCHING_SITE_USERS_ERROR:
      return {
        ...state,
        error:
          action.type === types.FETCHING_SITE_USERS_ERROR ? action.error : null,
        siteUsers: {
          data:
            action.type === types.FETCHING_SITE_USERS_SUCCESS
              ? {
                  ...state.siteUsers.data,
                  [action.siteId]: action.siteUsers,
                }
              : state.siteUsers.data,
          isLoading: action.type === types.FETCHING_SITE_USERS,
        },
      }

    case types.CREATING_SITE_USER:
    case types.CREATING_SITE_USER_SUCCESS:
    case types.CREATING_SITE_USER_ERROR:
      return {
        ...state,
        error:
          action.type === types.CREATING_SITE_USER_ERROR ? action.error : null,
        siteUsers: {
          ...state.siteUsers,
          addBulkUsersResponse:
            action.type === types.CREATING_SITE_USERS_SUCCESS
              ? {
                  newSiteUsers: action.siteUsers,
                  failedSiteUsers: action.failedSiteUsers,
                }
              : null,
          data:
            action.type === types.CREATING_SITE_USER_SUCCESS
              ? {
                  ...state.siteUsers.data,
                  [action.siteUser.siteId]: [
                    ...state.siteUsers.data[action.siteUser.siteId],
                    action.siteUser,
                  ],
                }
              : state.siteUsers.data,
          isUpdating: action.type === types.CREATING_SITE_USER,
        },
      }
    case types.CREATING_SITE_USERS:
    case types.CREATING_SITE_USERS_SUCCESS:
    case types.CREATING_SITE_USERS_ERROR:
      const siteId = action.siteId
      return {
        ...state,
        error:
          action.type === types.CREATING_SITE_USERS_ERROR ? action.error : null,
        siteUsers: {
          ...state.siteUsers,
          addBulkUsersResponse:
            action.type === types.CREATING_SITE_USERS_SUCCESS
              ? {
                  newSiteUsers: action.newSiteUsers,
                  failedSiteUsers: action.failedSiteUsers,
                  invalidSiteUsers: action.invalidSiteUsers,
                  sendEmail: action.sendEmail,
                }
              : null,
          data:
            action.type === types.CREATING_SITE_USERS_SUCCESS
              ? {
                  ...state.siteUsers.data,
                  [siteId]: [
                    ...state.siteUsers.data[siteId],
                    ...action.newSiteUsers,
                  ],
                }
              : state.siteUsers.data,
          isLoading: action.type === types.CREATING_SITE_USERS,
          isBulkOperationCompleted: action.type !== types.CREATING_SITE_USERS,
        },
      }

    case types.REMINDING_SITE_USER:
    case types.REMINDING_SITE_USER_SUCCESS:
    case types.REMINDING_SITE_USER_ERROR:
      return {
        ...state,
        error:
          action.type === types.REMINDING_SITE_USER_ERROR ? action.error : null,
        remindUsers: {
          success: action.type === types.REMINDING_SITE_USER_SUCCESS,
          isLoading: action.type === types.REMINDING_SITE_USER,
        },
      }

    case types.UPDATING_SITE_USER:
    case types.UPDATING_SITE_USER_SUCCESS:
    case types.UPDATING_SITE_USER_ERROR:
      let newSiteUsers
      if (action.type === types.UPDATING_SITE_USER_SUCCESS) {
        newSiteUsers = [...state.siteUsers.data[action.siteUser.siteId]]

        const siteUserIndex = newSiteUsers.findIndex(
          siteUser => siteUser.id === action.siteUser.id,
        )
        newSiteUsers[siteUserIndex] = action.siteUser
      }
      return {
        ...state,
        error:
          action.type === types.UPDATING_SITE_USER_ERROR ? action.error : null,
        siteUsers: {
          ...state.siteUsers,
          data:
            action.type === types.UPDATING_SITE_USER_SUCCESS
              ? {
                  ...state.siteUsers.data,
                  [action.siteUser.siteId]: newSiteUsers.filter(
                    u => u.isActive === true,
                  ),
                }
              : state.siteUsers.data,
          isUpdating: action.type === types.UPDATING_SITE_USER,
        },
      }
    case types.RESET_BULK_ADD_USERS:
      return {
        ...state,
        siteUsers: {
          ...state.siteUsers,
          isBulkOperationCompleted: false,
          addBulkUsersResponse: null,
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/sitesManager/reducers.js